module.exports = __webpack_public_path__ + "assets/scroll-arrow.1c0f6fc6.svg";